import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ChevronIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 13 12" {...props} ref={ref}>
          <g id="Frame 28">
            <path
              id="Vector 27"
              d="M0.600098 3.2998L6.0001 8.6998L11.7001 3.2998"
              stroke="currentColor"
              strokeLinecap="round"
              fill="none"
            />
          </g>
        </svg>
      </Icon>
    );
  },
);

ChevronIcon.displayName = "ChevronIcon";
